<template>
  <div>

    <cc-collapse :title="$t('ct-general-settings')">

      <div class="form-group">

        <div class="form-check">
          <input v-model="config.autoplay" @change="save" class="form-check-input" type="checkbox" id="autoplay">
          <label class="form-check-label" for="autoplay">
            Autoplay
          </label>
        </div>
        <div class="form-check">
          <input v-model="config.countdown" @change="save" class="form-check-input" type="checkbox" id="countdown">
          <label class="form-check-label" for="countdown">
            Countdown
          </label>
        </div>
        <div class="form-check">
          <input v-model="config.loop" @change="save" class="form-check-input" type="checkbox" id="loop">
          <label class="form-check-label" for="loop">
            Loop
          </label>
        </div>

        <div class="form-check">
          <input v-model="config.controls" @change="save" class="form-check-input" type="checkbox" id="controls">
          <label class="form-check-label" for="controls">
            Controls
          </label>
        </div>

      </div>


    </cc-collapse>

    <cc-collapse @click="getVideos" :title="$t('ct-videos')">


      <div class="form-group">


        <label for="">{{ $t('ct-available-videos') }}</label>

        <div v-for="(video, idx) in videos" :key="idx" class="form-check">
          <input class="form-check-input" v-model="selectedVideo" @change="save()" type="radio" name="flexRadioDefault"
                 :value="video.secret" :id="video.secret">
          <label class="form-check-label" :for="video.secret">
            {{ video.name }}
          </label>
        </div>
        <br>
        <button @click="getVideos" class="btn btn-secondary">{{ $t('ct-update') }}</button>
      </div>

    </cc-collapse>

    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig"></cc-slider-component>
      <cc-slider-component ref="heightconfig"></cc-slider-component>
      <cc-slider-component ref="minHeightConfig"></cc-slider-component>
      <cc-slider-component ref="minWidthTabletConfig"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-animation')">
      <cc-animation ref="animation"></cc-animation>
    </cc-collapse>

    <cc-collapse :title="$t('ct-padding')" class="padding-mobile">
      <cc-padding ref="padding"></cc-padding>
    </cc-collapse>

    <cc-collapse :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

    <cc-collapse :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>
</template>

<script>

import axios from 'axios'
import {getVideoHosting} from '../../../../js/services/editor/integrations'
import MixinComponentsOptions from "../../../../js/mixins/MixinComponentsOptions";

export default {
  name: 'VideoOptions',
  mixins: [MixinComponentsOptions],
  data() {
    return {
      config: {},
      videos: [],
      selectedVideo: '',
      callback: () => {
      }
    };
  },
  methods: {
    init(config, callback) {
      let vm = this;
      vm.config = _.clone(config);
      vm.callback = callback;
      vm.selectedVideo = vm.config.secret

      this.$refs['widthConfig'].setValues({
        defaultValue: vm.config.width,
        defaultValueChecked: true,
        min: 50,
        max: 2000,
        canBeCheckbox: false,
        labelDesc: 'width',
        name: 'iconColor',
        callback: vm.setWidth
      });
      this.$refs['heightconfig'].setValues({
        defaultValue: vm.config.height,
        defaultValueChecked: true,
        min: 0,
        max: 1000,
        canBeCheckbox: false,
        labelDesc: 'height',
        name: 'iconColor',
        callback: vm.setHeight
      });

      this.$refs['minWidthTabletConfig'].setValues({
        defaultValue: vm.config.maxWidth,
        defaultValueChecked: true,
        min: 50,
        max: 800,
        canBeCheckbox: false,
        labelDesc: 'max-width-tablet',
        name: 'iconColor',
        callback: vm.setMaxWidth
      });

      // animation
      this.$refs['animation'].setValues({
        action: vm.config.animation.in.action,
        effect: vm.config.animation.in.effect,
        scroll: vm.config.animation.in.scroll,
        time: vm.config.animation.in.time,
        speed: vm.config.animation.in.speed,
        infinite: vm.config.animation.in.infinite,
        labelDesc: 'animate',
        name: 'animate',
        callback: vm.setAnimation
      }, null);

      // padding
      this.$refs['padding'].setValues({
        defaultTop: vm.config.paddingTop,
        defaultBottom: vm.config.paddingBottom,
        defaultLeft: vm.config.paddingLeft,
        defaultRight: vm.config.paddingRight,
        min: 0,
        max: 100,
        labelDesc: 'padding',
        callback: vm.setPadding
      });


      // tag
      this.$refs['tag'].setValues({tag: vm.config.tag, callback: vm.setTag});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});

      this.$refs['minHeightConfig'].setValues({
        defaultValue: vm.config.minHeight,
        defaultValueChecked: true,
        min: 10,
        max: 800,
        canBeCheckbox: false,
        labelDesc: 'mobile-height',
        name: 'iconColor',
        callback: vm.setMinHeight
      });

    },

    getVideos() {
      getVideoHosting()
        .then((res) => {
          this.videos = res.data.data
        })
    },
    setHeight(value) {
      this.config.height = `${value}px`;
      this.save();
    },
    setMinHeight(value) {
      this.config.minHeight = `${value}px`;
      this.save();
    },
    save() {
      this.config.secret = this.selectedVideo;
      this.callback(this.config);
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Video/Options.vue